<p>
  Функцията за харесване ви позволява бързо да отбележите обяви, които ви интересуват, и да ги запазите за по-късно.
  Това е удобен начин да следите потенциални покупки, без да се налага да ги търсите отново.
</p>
<h6 class="mt-3">Как може да харесате обява?</h6>
<p class="mb-1">
  Имате два основни начина да отбележите обява като любима:
</p>
<ul>
  <li>
    От <strong>страницата на самата обява</strong>, чрез бутона със сърце, разположен в горния ляв ъгъл на
    фотогалерията.
  </li>
  <li>
    От <strong>списъка с обяви</strong>, където всяка обява също разполага с икона за бързо харесване.
  </li>
</ul>
<h6 class="mt-3">Къде се съхраняват харесаните обяви?</h6>
<p>
  Всички харесани обяви автоматично се събират в личната ви секция <strong>„Профил“ → „Харесани обяви“</strong>. Така
  лесно ще имате достъп до интересни артикули, към които бихте искали да се върнете по-късно.
</p>
<p>
  В страницата на всяка обява ще откриете бутон <strong>„Харесвания (n)”</strong>, който показва колко потребители са я
  отбелязали като любима. При клик върху него ще се отвори списък с всички, които са харесали обявата.
</p>
<h6 class="mt-3">Популярност на обявите</h6>
<p>
  Обявите с по-голям брой харесвания могат да бъдат отбелязани като <strong>популярни</strong> и да се показват в
  специални секции на началната страница на сайта. Това увеличава тяхната видимост и повишава шансовете за продажба.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Използвайте функцията за харесване като свой личен списък с любими обяви, който ви помага да
  следите интересни оферти.
</div>
